<template>
  <div>
    <template v-if="rowdata">
      <template v-if="inputs">
        <TableItemVue
          :input="inputs"
          :type="inputs.component.name"
          :rowdata="rowdata"
          :rowall="rowall"
        />
      </template>
      <template v-else>{{ rowdata }}</template>
    </template>
  </div>
</template>
<script>
import TableItemVue from "../Ui/TableItem.vue";

export default {
  components: {
    TableItemVue: TableItemVue
  },
  props: {
    rowdata: [String, Number],
    rowall: Object,
    inputs: Object,
    table: String,
    detailurl: String,
    fieldtype: String
  }
};
</script>

<style></style>
